var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`h${_vm.size}`,{tag:"component",staticClass:"c-title",class:_vm.titleClasses},[(_vm.icon)?_c('c-icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"size":_vm.iconSize}}):_vm._e(),_c('span',{staticClass:"text"},[_vm._t("default")],2),(!_vm.noBorder)?_c('span',{class:_vm.borderClasses,style:(_vm.borderStyles)}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }